import { render, staticRenderFns } from "./ParentDetail.vue?vue&type=template&id=8f38f898"
import script from "../../controllers/parent/parent-detail.js?vue&type=script&lang=js&external"
export * from "../../controllers/parent/parent-detail.js?vue&type=script&lang=js&external"
import style0 from "./ParentDetail.vue?vue&type=style&index=0&id=8f38f898&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports